import React, {useEffect, useState, useRef, useCallback} from 'react'
import {Trans, useTranslation} from "react-i18next";
import {IconPlaceCircle, ModalDescription, ModalInfo} from "./modal.info";
import Api from "../../service/api";
import {Loader, OverlayLoader} from "../loader";
import FormGen from "../form/formgen2";
import {useToasts} from "react-toast-notifications";
import {copyToClipboard, getMinutesToDateFromNow} from "../../helper";
import {Action} from "../datatable";
import {useDashboard, usePaymentOrder} from "../../service/api.swr";
import {FINANCE} from "../../config/resources";
import {useDispatch} from "react-redux";
import {UserAction} from "../../redux/reducers/user";
import QRCodeStyling from "qr-code-styling";
import {IconCopy, IconPlus, IconUsdt, IconWallet} from "../icons";
import styled from 'styled-components'
import {CURRENCY_USDT, CURRENCY_USDT_TRC20} from "../../constants";
import {ButtonSecondary} from "../button";
import {AlertErrorSmall, AlertSuccessSmall} from "../alert";
import {ContentContainer, DetailContainer, DetailLabel, DetailValue} from "./modal.withdraw";

const MODAL_WIDTH = '400px'
const MODAL_WIDTH_BIG = '620px'

export const LinkContainer = styled.div`
    display: flex;
    height: 40px;
    padding: 0px 16px;
    margin-bottom: 12px;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
    align-self: stretch;

    background: var(--it-bg-buttons);
`

export const IconPlace = styled.span`

`

export const Currency = styled.span`
    color: var(--it-text-white);
    /* Body */
    font-family: "Basis Grotesque Pro";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 16.8px */
    letter-spacing: 0.42px;
`

const PayHeader = styled.div`
    display: flex;
    justify-content: space-between;
`

const PayDetails = styled.div`
    
`

const PayTitleCont = styled(LinkContainer)`
    margin-top: 12px;
    margin-bottom: 0;
    padding-left: 0;
    background-color: unset;
`

const PayTitle = styled.p`
    color: var(--it-text-white);
    /* H4 */
    font-family: "Druk Wide";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%; /* 16.8px */
    letter-spacing: 0.42px;
    text-transform: uppercase;
`

const PayQrCode = styled.div`
    width: 80px;
    height: 80px;
    aspect-ratio: 1/1;

    fill: var(--it-bg-cards);
`

const PayFooter = styled.div`
    display: flex;
    height: 48px;
    padding: 0 6px;
    margin-top: 12px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;

    background: var(--it-bg-cards);
`

const PayAddr = styled.div`
    margin-left: 16px;
    margin-right: auto;
`

const PayLabel = styled.p`
    color: var(--it-text-white);
    /* Body */
    font-family: "Basis Grotesque Pro";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 16.8px */
    letter-spacing: 0.42px;
`

const PayValue = styled(PayLabel)`
    color: var(--it-text-grey);
    font-size: 12px;
`

export const InfoContWithTextCopy = ({icon, label, text}) => {
    const {t} = useTranslation();

    return (
      <PayFooter>
          <IconPlaceCircle data-rectangle>{icon}</IconPlaceCircle>
          <PayAddr>
              <PayLabel>{label}</PayLabel>
              <PayValue onClick={()=>copyToClipboard(text)}>{text}</PayValue>
          </PayAddr>
          <ButtonSecondary onClick={()=>copyToClipboard(text)}>
              <IconCopy size={20}></IconCopy>
              {t(`modal.topup.button_copy`)}
          </ButtonSecondary>
      </PayFooter>
    )
}

function GetWallet({onWalletReceived}){
    const {t} = useTranslation();

    const [formFields, setFormFields] = useState([
        {
            name: 'currency',
            type: 'hidden',
            defaultValue: 'usdttrc20'
        },
    ], []);

    const onSubmit = (formData, setError, setAlerts) => {
        return Api.getCSRFCookie().then(() => Api.paymentGetWallet(formData.currency));
    }

    return (
        <>
            <LinkContainer style={{marginBottom: '0'}}>
                <IconPlace>
                    <IconUsdt size={24} />
                </IconPlace>
                <Currency>{CURRENCY_USDT_TRC20}</Currency>
            </LinkContainer>

            <FormGen items={formFields}
                // initialValues={{}}
                     onSubmit={onSubmit}
                     onComplete={onWalletReceived}
                     submitText={t(`modal.getwallet.btn_getwallet`)}
                     submitBtnStyles={{width: '100%'}}
            />
        </>
    )
}

function TopUpForm({onPaymentCreated}){
    const {t} = useTranslation();
    const formRef = useRef()
    const updateFieldAmount = useCallback((amount, e)=>{
        e.preventDefault();
        e.stopPropagation();
        formRef.current.setValue('amount', amount)
    }, [formRef])

    const [formFields, setFormFields] = useState([
        {
            name: 'currency',
            type: 'hidden',
            defaultValue: 'usdttrc20'
        },
        {
            label: t('form.field.amount'),
            error: {
                required: t('form.error.required', {name: t('form.field.amount')}),
                min: {
                    value: 10,
                    message: t('form.error.min', {value: 10, name: t('form.field.amount')}),
                }
            },
            defaultValue: 0,
            name: 'amount',
            type: 'text',
            placeholder: t('form.field.placeholder', {name: t('form.field.amount_topup_placeholder')}),
            hint: <div className={`flex flex-row gap-2 text-xs`}>
                {[200,500,1000,2500].map((amount, idx)=>{
                    return <a key={`${idx}:${amount}`} href={"#"} className={`link`}
                              onClick={(e)=>updateFieldAmount(amount, e)}>${amount}</a>
                })}
            </div>,
        },
    ], [formRef]);

    const onSubmit = (formData, setError, setAlerts) => {
        return Api.getCSRFCookie().then(() => Api.paymentTopUp(formData.currency, formData.amount));
    }

    return (
        <>
            <FormGen ref={formRef}
                     items={formFields}
                // initialValues={{}}
                     onSubmit={onSubmit}
                     onComplete={onPaymentCreated}
                     submitText={t(`modal.topup.btn_save`)}
                     submitBtnStyles={{width: '100%'}}
                     contentBeforeSubmitBtn={(
                       <>
                           <LinkContainer style={{width: '100%'}}>
                               <IconPlace>
                                   <IconUsdt size={24} />
                               </IconPlace>
                               <Currency>{CURRENCY_USDT_TRC20}</Currency>
                           </LinkContainer>
                       </>
                     )}
            />
        </>
    )
}

const qrCodePayAddress = new QRCodeStyling({
    "width": 80,
    "height": 80,
    "data": "",
    "margin": 0,
    "qrOptions": {
        "typeNumber": "0",
        "mode": "Byte",
        "errorCorrectionLevel": "Q"
    },
    "imageOptions": {
        "hideBackgroundDots": true,
        "imageSize": 0.5,
        "margin": 0
    },
    "dotsOptions": {
        "type": "dots",
        "color": "#000000",
        "gradient": null
    },
    "backgroundOptions": {
        "color": "#ffffff"
    },
    "image": "",
    "dotsOptionsHelper": {
        "colorType": {
            "single": true,
            "gradient": false
        },
        "gradient": {
            "linear": true,
            "radial": false,
            "color1": "#000000",
            "color2": "#000000",
            "rotation": "0"
        }
    },
    "cornersSquareOptions": {
        "type": "extra-rounded",
        "color": "#000000"
    },
    "cornersSquareOptionsHelper": {
        "colorType": {
            "single": true,
            "gradient": false
        },
        "gradient": {
            "linear": true,
            "radial": false,
            "color1": "#000000",
            "color2": "#000000",
            "rotation": "0"
        }
    },
    "cornersDotOptions": {
        "type": "dot",
        "color": "#000000",
        "gradient": null
    },
    "cornersDotOptionsHelper": {
        "colorType": {
            "single": true,
            "gradient": false
        },
        "gradient": {
            "linear": true,
            "radial": false,
            "color1": "#000000",
            "color2": "#000000",
            "rotation": "0"
        }
    },
    "backgroundOptionsHelper": {
        "colorType": {
            "single": true,
            "gradient": false
        },
        "gradient": {
            "linear": true,
            "radial": false,
            "color1": "#ffffff",
            "color2": "#ffffff",
            "rotation": "0"
        }
    }
});
function Payment({isStaticAddress, orderId, payAddress, payAmount, payCurrency, payStatus, expireTime}){
    const {t} = useTranslation();
    const [expireMinutes, setExpireMinutes] = useState(60);
    const [intervalId, setIntervalId] = useState(false);
    const {order, isLoading, isError} = usePaymentOrder(orderId, true);
    const dispatch = useDispatch()
    const ref = useRef(null);

    useEffect(() => {
        qrCodePayAddress.append(ref.current);
    }, []);

    useEffect(() => {
        qrCodePayAddress.update({
            data: payAddress
        });
    }, [payAddress]);

    useEffect(()=>{
        if(isStaticAddress) return;

        setExpireMinutes(getMinutesToDateFromNow(expireTime));
        let _intervalId = setInterval(()=>setExpireMinutes(getMinutesToDateFromNow(expireTime)), 1000);
        setIntervalId(_intervalId);

        return ()=>{
            clearInterval(intervalId);
            setIntervalId(false);
        }
    }, [isStaticAddress])

    useEffect(()=>{
        if(expireMinutes !== false) return;
        clearInterval(intervalId)
        setIntervalId(false);
    }, [expireMinutes, intervalId])

    //disable user balance reload, becourse bug with table refresh after user update
    // useEffect(()=>{
    //     if(!order?.status) return;
    //
    //     if(order?.status === FINANCE.STATUS.IN_PROGRESS) return;
    //     dispatch(UserAction.loadUserInfo());
    // }, [order?.status])

    if (order?.status === FINANCE.STATUS.COMPLETED && order?.data?.payment_status === 'finished') {
        const paidAmount = order?.data?.paid_amount
        const paidAmountFormat = paidAmount ? parseFloat(paidAmount) : paidAmount

        return (
          <>
              <AlertSuccessSmall title={(
                <div style={{width: '100%', textAlign: 'center'}}>
                    <p>{t(`modal.topup.payment_finished_success`)}</p>
                    <p>{t(`modal.topup.payment_finished_success_cta`)}</p>
                </div>
              )}/>

              <ContentContainer style={{marginTop: '12px'}}>
                  <DetailContainer style={{width: '100%', alignItems: 'center'}}>
                      <DetailLabel>
                          {t(`form.field.amount`)}
                      </DetailLabel>
                      <DetailValue>
                          {`+`}{paidAmountFormat}{` `}{CURRENCY_USDT}
                      </DetailValue>
                  </DetailContainer>

                  <DetailContainer style={{width: '100%', alignItems: 'center'}}>
                      <DetailLabel>
                          {t(`widget.balance.title`)}
                      </DetailLabel>
                      <DetailValue>
                          {order?.balance_new}{` `}{CURRENCY_USDT}
                      </DetailValue>
                  </DetailContainer>
              </ContentContainer>
          </>
        )
    }

    return (
      <>
          {expireMinutes <= 0 && !isStaticAddress ?
            <AlertErrorSmall title={t(`modal.topup.payment_expired`)} />
            : <>
                <PayHeader>
                    <PayDetails>
                        <ModalDescription style={{width: '80%'}}>
                            {t(`modal.getwallet.static_wallet_description`)}
                        </ModalDescription>
                        {/*<PayTitle>{payAmount} {payCurrency}</PayTitle>*/}

                        <PayTitleCont>
                            <IconPlace>
                                <IconUsdt size={24} />
                            </IconPlace>
                            <PayTitle style={{paddingTop: '3px'}}>{CURRENCY_USDT_TRC20}</PayTitle>
                        </PayTitleCont>

                    </PayDetails>
                    <PayQrCode ref={ref} />
                </PayHeader>


                {
                    !isStaticAddress && expireMinutes &&
                        <ContentContainer style={{marginTop: '12px'}}>
                            <DetailContainer style={{width: '100%', alignItems: 'center'}}>
                                <DetailLabel>
                                    {t(`modal.topup.minutes_to_expire`)}
                                </DetailLabel>
                                <DetailValue style={{fontSize: '36px'}}>
                                    {expireMinutes}
                                </DetailValue>
                            </DetailContainer>
                        </ContentContainer>
                }

                {!isStaticAddress &&
                  /*<div className={`text-center py-2 flex flex-col items-center`}>
                      <div className={`uppercase text-base 
                                    ${order?.status === FINANCE.STATUS.COMPLETED && 'text-green-800'}
                                    ${order?.status === FINANCE.STATUS.ERROR && 'text-red-800'}
                                    `}>{order?.data?.payment_status || payStatus}</div>
                      {order?.status === FINANCE.STATUS.IN_PROGRESS && <Loader show={true} className={"my-2"} size={8} />}
                  </div>*/
                  <ContentContainer style={{marginTop: '12px'}}>
                      <DetailContainer style={{width: '100%', alignItems: 'center'}}>
                          <DetailValue style={{fontSize: '16px'}}>
                              {order?.data?.payment_status || payStatus}
                          </DetailValue>

                          {order?.status === FINANCE.STATUS.IN_PROGRESS && <Loader show={true} className={"my-2"} size={8} />}
                      </DetailContainer>
                  </ContentContainer>
                }

                <InfoContWithTextCopy
                    icon={<IconWallet size={20} />}
                    label={t(`modal.topup.info_pay_qr_to_addr`)}
                    text={payAddress}
                />
            </>
          }
      </>
    )
}

export const ModalTopUp = ({
                                 onConfirm,
                                 ...rest
                             }) => {
    /*const fakePayment = {
        is_static_address: true,
        order_id: '999',
        pay_address: 'TTa1KAUYs93CKrcUdqnKhG9pYJ4suJ45kQ',
        pay_amount: 100500,
        pay_currency: 'USD',
        expiration_estimate_date: new Date("June 09, 2026 15:00:00"),
        payment_status: 'pay_status_success',

    }*/
    const {t} = useTranslation();
    const [payment, setPayment] = useState(false);

    const onPaymentCreated = useCallback((_payment)=>{
        setPayment(_payment);
    }, [])

    useEffect(()=>{
        setPayment(false);
    }, [rest.isOpen])
    return (
        <ModalInfo
            {...rest}
            isModal={true}
            width={payment ? MODAL_WIDTH_BIG : MODAL_WIDTH}
            maxWidth={`max-w-xs sm:max-w-lg md:max-w-xl lg:max-w-2xl`}
            icon={<IconPlus size={20} />}
            title={t('modal.topup.title')}
            body={
                <>
                    {payment ? <Payment
                        isStaticAddress={payment.is_static_address}
                        orderId={payment.order_id}
                        payAddress={payment.pay_address}
                        payAmount={payment.pay_amount}
                        payCurrency={payment.pay_currency}
                        expireTime={payment.expiration_estimate_date}
                        payStatus={payment.payment_status}
                      />
                      : <TopUpForm onPaymentCreated={onPaymentCreated} />
                      // : <GetWallet onWalletReceived={onPaymentCreated}/>
                    }
                </>
            }
        />
    )
}


